import { ButtonProps } from "../../../../types"
import { cn } from "../../../utils"
import Button from "../button"

const DefaultBtn = ({ children, className, ...rest }: ButtonProps) => (
  <Button
    {...rest}
    className={cn(
      "border-gray-300 bg-white text-gray-500 hover:bg-gray-50",
      className
    )}
  >
    {children}
  </Button>
)

export default DefaultBtn
